export default "__VITE_ASSET__DhS3V5w6__"